import React from 'react';
import {
  FEATURE_MATRIX,
  displayPlansForCurrency,
  featureCellValue,
} from '../lib/pricingCatalog';

const TIER_COLUMNS = ['trial', 'enterprise'];

const LIMIT_ROWS = [
  { key: 'products', label: 'Products (SKUs)', field: 'products' },
  { key: 'qrCodes', label: 'QR codes / month', field: 'qrCodes' },
  { key: 'scans', label: 'Scans / month', field: 'scans' },
  { key: 'adminSeats', label: 'Admin users', field: 'adminSeats' },
  { key: 'mobileSeats', label: 'Mobile field users', field: 'mobileSeats' },
  { key: 'workflows', label: 'Workflow templates', field: 'workflows' },
];

function formatLimit(value) {
  if (value == null || value === '') return 'Unlimited';
  return Number(value).toLocaleString();
}

function tierLabel(slug) {
  if (slug === 'trial') return 'Trial';
  return slug.charAt(0).toUpperCase() + slug.slice(1);
}

export default function FeatureComparisonTable({ currency = 'INR', apiPlans = [] }) {
  const plans = displayPlansForCurrency(currency, apiPlans);
  const bySlug = Object.fromEntries(plans.map((p) => [p.slug, p]));

  return (
    <div className="mt-12">
      <h2 className="text-xl font-heading font-semibold text-zinc-900 mb-1">Compare plans</h2>
      <p className="text-sm text-zinc-500 mb-4">Feature packaging and volume limits by tier.</p>
      <div className="overflow-x-auto rounded-lg border border-zinc-200">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-50 text-zinc-600">
            <tr>
              <th className="text-left p-3 font-semibold min-w-[180px]">Feature</th>
              {TIER_COLUMNS.map((slug) => (
                <th key={slug} className="text-left p-3 font-semibold whitespace-nowrap">
                  {tierLabel(slug)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {LIMIT_ROWS.map((row) => (
              <tr key={row.key} className="border-t border-zinc-100">
                <td className="p-3 text-zinc-700 font-medium">{row.label}</td>
                {TIER_COLUMNS.map((slug) => (
                  <td key={`${slug}-${row.key}`} className="p-3 text-zinc-600 whitespace-nowrap">
                    {formatLimit(bySlug[slug]?.limits?.[row.field])}
                  </td>
                ))}
              </tr>
            ))}
            {FEATURE_MATRIX.map((row) => (
              <tr key={row.key} className="border-t border-zinc-100">
                <td className="p-3 text-zinc-700 font-medium">{row.label}</td>
                {TIER_COLUMNS.map((slug) => (
                  <td key={`${slug}-${row.key}`} className="p-3 text-zinc-600 whitespace-nowrap">
                    {featureCellValue(bySlug[slug]?.featurePackaging, row.key)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
